<template>
  <nav class="trail">
    <Container>
      <List class="trail__list">
        <li class="trail__item" v-for="(item, index) in trail" :key="index">
          <a v-if="index == 0" class="trail__link icon-link" :href="item.path">
            <Icon svg="home" />
            {{ item.tag }}
          </a>
          <template v-else-if="index == trail.length - 1">
            {{ item.tag }}
          </template>
          <router-link v-else :to="item.path">
            {{ item.tag }}
          </router-link>
        </li>
      </List>
    </Container>
  </nav>
</template>
<script>
import { getTrail } from "@/interface-data.js";
import Icon from "@/components/ui/atoms/Icon";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List";
export default {
  components: {
    Container,
    List,
    Icon
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const staticTrail = getTrail();
    const trail = [...staticTrail, ...props.list];
    return {
      trail
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.trail {
  padding: 1em 0;
  background-color: variables.$background-lighter-color;
  border-bottom: 1px solid variables.$border-trail-color;
  border-top: 0;
  &__list {
    display: flex;
    flex-grow: 1;
    overflow: auto;
    grid-column-gap: 0.2rem;
    column-gap: 0.2rem;
    list-style: none;
    mask-image: linear-gradient(270deg, transparent 1%, #000 40px);
  }
  &__item {
    display: inline;
    color: var(--color-txt);
    white-space: nowrap;
    &:not(:first-of-type):before {
      content: "|";
      margin: 1em;
    }
  }
}
</style>
